import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

export default function Hero({
  title = "Best & Cheapest Hotels in Dubai",
  subtitle = "Find the perfect hotel in Dubai with exclusive local deals, unbeatable prices and a hassle-free booking experience.",
  backgroundImage,
  backgroundImages = [],
  variant = "inner",
  overlayOpacity = "bg-black/10",
  children,
  slideInterval = 5000,
}) {
  const isHome = variant === "home";

  const [current, setCurrent] = useState(0);

  // =========================================================
  // AUTO SLIDER
  // =========================================================

  useEffect(() => {
    if (!isHome || backgroundImages.length <= 1) {
      return;
    }

    const interval = setInterval(() => {
      setCurrent((prev) => {
        return (prev + 1) % backgroundImages.length;
      });
    }, slideInterval);

    return () => clearInterval(interval);
  }, [isHome, backgroundImages, slideInterval]);

  // =========================================================
  // ACTIVE IMAGE
  // =========================================================

  const activeImage =
    backgroundImages.length > 0
      ? backgroundImages[current]
      : backgroundImage;

  // =========================================================
  // HOME HERO
  // =========================================================

  if (isHome) {
    return (
      <section
        className="
    relative
    w-full
    overflow-visible
    bg-white
   mt-28

  

   
  "
      >
        {/* =====================================================
            HERO IMAGE
        ===================================================== */}

        <div
          className="
    relative
    h-[360px]
    w-full
    overflow-hidden

    sm:h-[380px]
    md:h-[400px]
    lg:h-[420px]
    xl:h-[430px]
  "
        >
          {/* =================================================
              BACKGROUND SLIDER
          ================================================= */}

          {backgroundImages.length > 0 ? (
            <>
              {backgroundImages.map((image, index) => (
                <div
                  key={index}
                  className="
                    absolute
                    inset-0

                    bg-cover
                    bg-center
                    bg-no-repeat

                    transition-opacity
                    duration-1000
                    ease-in-out
                  "
                  style={{
                    backgroundImage: `url(${image})`,
                    opacity: index === current ? 1 : 0,
                  }}
                />
              ))}
            </>
          ) : (
            activeImage && (
              <div
                className="
                  absolute
                  inset-0

                  bg-cover
                  bg-center
                  bg-no-repeat
                "
                style={{
                  backgroundImage: `url(${activeImage})`,
                }}
              />
            )
          )}

          {/* =================================================
              LEFT NAVY OVERLAY

              Matches attached design.
              No red.
          ================================================= */}

          <div
            className="
              pointer-events-none
              absolute
              inset-0

              bg-gradient-to-r

              from-[#062F4F]/90
              via-[#062F4F]/62
              via-[48%]
              to-transparent
            "
          />

          {/* =================================================
              VERY LIGHT BOTTOM FADE
          ================================================= */}

          <div
            className="
              pointer-events-none
              absolute
              inset-x-0
              bottom-0
              h-[80px]

              bg-gradient-to-t
              from-[#062F4F]/35
              to-transparent
            "
          />

          {/* =================================================
              HERO CONTENT
          ================================================= */}

          <div
            className="
  relative
  z-10

  mx-auto

  flex
  h-full
  w-full max-w-[1536px]

  items-center

 px-4
            sm:px-6
            lg:px-8
  py-10

  sm:py-11

  md:py-12

  lg:py-14

"
          >
            <div
              className="
                max-w-[620px]
                text-left
              "
            >
              {/* =================================================
                  EYEBROW
              ================================================= */}

              <div
                className="
                  mb-2

                  flex
                  items-center
                  gap-2

                  text-[8px]
                  font-bold
                  uppercase
                  tracking-[0.16em]

                  text-white/90

                  sm:text-[9px]
                  md:text-[10px]
                "
              >
                <span
                  className="
                    h-[2px]
                    w-6

                    rounded-full

                    bg-[#F7B928]
                  "
                />

                <span>
                  Discover Dubai, Stay for Less
                </span>
              </div>

              {/* =================================================
                  MAIN TITLE
              ================================================= */}

              <h1
                className="
                  max-w-[570px]

                  text-[31px]
                  font-extrabold

                  leading-[0.98]

                  tracking-[-0.04em]

                  text-white

                  drop-shadow-[0_3px_12px_rgba(0,0,0,0.30)]

                  sm:text-[37px]

                  md:text-[43px]

                  lg:text-[49px]
                "
              >
                Best & Cheapest
                <br />

                <span className="text-[#F7B928]">
                  Hotels in Dubai
                </span>
              </h1>

              {/* =================================================
                  DESCRIPTION
              ================================================= */}

              <p
                className="
                  mt-2

                  max-w-[510px]

                  text-[9px]
                  leading-4

                  text-white/90

                  sm:text-[10px]
                  sm:leading-4

                  md:text-[11px]
                  md:leading-5

                  lg:text-[12px]
                "
              >
                Find the perfect hotel in Dubai with exclusive
                local deals, unbeatable prices and a hassle-free
                booking experience.
              </p>

              {/* =================================================
                  TRUST POINTS
              ================================================= */}

              <div
                className="
                  mt-3

                  flex
                  flex-wrap
                  items-center

                  gap-x-4
                  gap-y-2

                  text-[8px]
                  font-medium

                  text-white

                  sm:text-[9px]
                  md:text-[10px]
                "
              >
                {/* Best Prices */}

                <div className="flex items-center gap-1.5">
                  <span
                    className="
                      flex
                      h-5
                      w-5
                      items-center
                      justify-center

                      rounded-full

                      bg-[#F7B928]

                      text-[10px]
                      font-bold

                      text-[#062F4F]
                    "
                  >
                    %
                  </span>

                  <span>
                    <span className="block font-bold">
                      Best Prices
                    </span>

                    <span className="block text-[7px] text-white/70">
                      Guaranteed
                    </span>
                  </span>
                </div>

                {/* Verified Hotels */}

                <div className="flex items-center gap-1.5">
                  <span
                    className="
                      flex
                      h-5
                      w-5
                      items-center
                      justify-center

                      rounded-full

                      bg-[#F7B928]

                      text-[9px]
                      font-bold

                      text-[#062F4F]
                    "
                  >
                    ✓
                  </span>

                  <span>
                    <span className="block font-bold">
                      Verified
                    </span>

                    <span className="block text-[7px] text-white/70">
                      Hotels
                    </span>
                  </span>
                </div>

                {/* Local Deals */}

                <div className="flex items-center gap-1.5">
                  <span
                    className="
                      flex
                      h-5
                      w-5
                      items-center
                      justify-center

                      rounded-full

                      bg-[#F7B928]

                      text-[9px]
                      font-bold

                      text-[#062F4F]
                    "
                  >
                    ●
                  </span>

                  <span>
                    <span className="block font-bold">
                      Local Deals
                    </span>

                    <span className="block text-[7px] text-white/70">
                      & Offers
                    </span>
                  </span>
                </div>

                {/* Support */}

                <div className="flex items-center gap-1.5">
                  <span
                    className="
                      flex
                      h-5
                      w-5
                      items-center
                      justify-center

                      rounded-full

                      bg-[#F7B928]

                      text-[9px]
                      font-bold

                      text-[#062F4F]
                    "
                  >
                    ♧
                  </span>

                  <span>
                    <span className="block font-bold">
                      24/7
                    </span>

                    <span className="block text-[7px] text-white/70">
                      Support
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              SLIDER DOTS
          ================================================= */}

          {backgroundImages.length > 1 && (
            <div
              className="
                absolute
                bottom-[48px]
                left-1/2
                z-20

                flex
                -translate-x-1/2

                items-center
                gap-1.5
              "
            >
              {backgroundImages.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  aria-label={`Go to slide ${index + 1}`}
                  onClick={() => setCurrent(index)}
                  className={`
                    h-1
                    rounded-full

                    transition-all
                    duration-300

                    ${index === current
                      ? "w-6 bg-[#F7B928]"
                      : "w-1.5 bg-white/60 hover:bg-white"
                    }
                  `}
                />
              ))}
            </div>
          )}
        </div>

        {/* =====================================================
            FLOATING SEARCH BOX

            This is intentionally much closer to the screenshot.
        ===================================================== */}

        {children && (
          <div
            className="
              relative
              z-30

              mx-auto

              -mt-[52px]

              w-[calc(100%-24px)]

              max-w-[1536px]
              px-4
            sm:px-6
            lg:px-8

              sm:-mt-[55px]
              sm:w-[calc(100%-40px)]

              md:w-[calc(100%-70px)]

              lg:-mt-[40px]
              lg:w-[calc(100%-100px)]

              xl:w-[calc(100%-140px)]
            "
          >
            <div
              className="
                rounded-[15px]

                border
                border-[#E3E9ED]

                bg-white

                p-2

                shadow-[0_12px_35px_rgba(6,47,79,0.18)]

                sm:rounded-[17px]
                sm:p-2.5

                lg:rounded-[19px]
                lg:p-3
              "
            >
              {children}
            </div>
          </div>
        )}
      </section>
    );
  }

  // ===========================================================
  // INNER PAGE HERO
  // ===========================================================

  return (
    <section
      className="
        relative
        mt-[76px]

        w-full
        overflow-hidden

        bg-[#F3F8FF]
      "
    >
      {/* BACKGROUND */}

      {activeImage && (
        <div
          className="
            absolute
            inset-0

            bg-cover
            bg-center
            bg-no-repeat
          "
          style={{
            backgroundImage: `url(${activeImage})`,
          }}
        />
      )}

      {/* NAVY OVERLAY */}

      <div
        className="
          absolute
          inset-0

          bg-gradient-to-r

          from-[#062F4F]/88
          via-[#062F4F]/62
          to-[#062F4F]/30
        "
      />

      {/* CONTENT */}

      <div
        className="
          relative
          z-10

          mx-auto

          flex

          min-h-[270px]

          w-full max-w-[1536px]

          items-center

          px-5
          py-14

          sm:min-h-[300px]
          sm:px-8

          md:min-h-[330px]

          lg:px-12
        "
      >
        <div
          className="
            max-w-[800px]
            text-left
            text-white
          "
        >
          {/* EYEBROW */}

          <div
            className="
              mb-4

              flex
              items-center
              gap-3

              text-[9px]
              font-bold
              uppercase
              tracking-[0.18em]

              text-white/90
            "
          >
            <span
              className="
                h-[2px]
                w-7

                rounded-full

                bg-[#F7B928]
              "
            />

            <span>
              Dubai Hotels
            </span>

            <span className="text-[#F7B928]">
              •
            </span>

            <span>
              Best Local Rates
            </span>
          </div>

          {/* TITLE */}

          <h1
            className="
              text-[34px]
              font-extrabold

              leading-[1]

              tracking-[-0.035em]

              text-white

              sm:text-[42px]
              md:text-[50px]
              lg:text-[58px]
            "
          >
            {formatHeroTitle(title)}
          </h1>

          {/* SUBTITLE */}

          {subtitle && (
            <p
              className="
                mt-4

                max-w-[650px]

                text-[12px]
                leading-5

                text-white/90

                md:text-sm
                md:leading-6
              "
            >
              {subtitle}
            </p>
          )}

          {/* EXTRA CONTENT */}

          {children && (
            <div className="mt-6">
              {children}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

// ===========================================================
// TITLE FORMATTER
// ===========================================================

function formatHeroTitle(title) {
  if (!title) {
    return null;
  }

  const normalizedTitle = title.toLowerCase();

  if (normalizedTitle.includes("dubai")) {
    const match = title.match(
      /^(.*?)(\s+in\s+)(dubai)(.*)$/i
    );

    if (match) {
      const before = match[1];
      const after = match[4];

      return (
        <>
          {before}
          <br />

          <span className="text-[#F7B928]">
            Dubai
          </span>

          {after}
        </>
      );
    }

    const parts = title.split(/(dubai)/i);

    return parts.map((part, index) => {
      if (part.toLowerCase() === "dubai") {
        return (
          <span
            key={index}
            className="text-[#F7B928]"
          >
            {part}
          </span>
        );
      }

      return (
        <React.Fragment key={index}>
          {part}
        </React.Fragment>
      );
    });
  }

  return title;
}